<script lang="ts">
  import {onDestroy} from 'svelte';

  import {tooltip} from '@/actions/tippy-action';
  import editorInstance from '../../editor';
  import editorStore from '../../editor.store';
  let activeComponent: any;
  let transparencyStyle: string;
  let container: HTMLElement;
  let t: number;
  let show = false;
  const unsubscribe = editorStore.subscribe(store => {
    if (activeComponent === store.activeComponent) return;
    activeComponent = store.activeComponent;
    if (!activeComponent) {
      show = false;
      return;
    }
    t = parseFloat(getComputedStyle(activeComponent).opacity);
  });

  const backgroundColor = 'black';

  $: transparencyStyle = `opacity: ${t}; background-color: ${backgroundColor}`;

  function updateOpacity() {
    activeComponent.style.opacity = t;
    const data_animations = activeComponent.getAttribute('data-animation');
    if (data_animations) {
      try {
        const animations = JSON.parse(data_animations);
        animations?.animations.forEach((animation: any) => {
          animation.opacity = t;
        });
        activeComponent.setAttribute('data-animation', JSON.stringify(animations));
      } catch (e) {
        console.error('Invalid JSON in data-animation attribute:', e);
        return;
      }
    }
    editorInstance.history.addHistory('Change Transparency');
  }

  function detectWindowClick(e: MouseEvent) {
    const target = e.target;
    if (!target) return;

    if (!container.contains(target as HTMLElement)) {
      show = false;
    }
    return;
  }

  onDestroy(unsubscribe);
</script>

<div
  use:tooltip={'Transparency'}
  class="btn relative flex cursor-pointer"
  bind:this={container}
  on:click={e => {
    show = !show;
  }}
  on:keypress={e => {
    show = !show;
  }}
>
  <div class="flex w-7 items-center justify-center">
    <svg
      class="rounded-md border border-gray-300"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="20 20 30 30"
      version="1.1"
      baseProfile="full"
      enable-background="new 0 0 76.00 76.00"
      xml:space="preserve"
    >
      <linearGradient
        id="SVGID_Fill1_"
        gradientUnits="objectBoundingBox"
        x1="0.853553"
        y1="0.853553"
        x2="1.85355"
        y2="0.853553"
        gradientTransform="rotate(225.000000 0.853553 0.853553)"
      >
        <stop offset="0" stop-color="#000000" stop-opacity="0" />
        <stop offset="1" stop-color="#000000" stop-opacity="1" />
      </linearGradient>
      <path
        fill="url(#SVGID_Fill1_)"
        stroke-width="0.2"
        stroke-linejoin="round"
        d="M 19,19L 25.3333,19L 25.3333,25.3333L 31.6667,25.3333L 31.6667,19L 38,19L 38,25.3333L 44.3333,25.3333L 44.3333,19L 50.6667,19L 50.6667,25.3333L 57,25.3333L 57,31.6667L 50.6667,31.6667L 50.6667,38L 57,38L 57,44.3333L 50.6667,44.3333L 50.6667,50.6667L 57,50.6667L 57,57L 50.6667,57L 50.6667,50.6667L 44.3333,50.6667L 44.3333,57L 38,57L 38,50.6667L 31.6667,50.6667L 31.6667,57L 25.3333,57L 25.3333,50.6667L 19,50.6667L 19,44.3333L 25.3333,44.3333L 25.3333,38L 19,38L 19,31.6667L 25.3333,31.6667L 25.3333,25.3333L 19,25.3333L 19,19 Z M 50.6667,38L 44.3333,38L 44.3333,44.3333L 50.6667,44.3333L 50.6667,38 Z M 50.6667,25.3333L 44.3333,25.3333L 44.3333,31.6667L 50.6667,31.6667L 50.6667,25.3333 Z M 44.3333,44.3333L 38,44.3333L 38,50.6667L 44.3333,50.6667L 44.3333,44.3333 Z M 38,44.3333L 38,38L 31.6667,38L 31.6667,44.3333L 38,44.3333 Z M 31.6667,44.3333L 25.3333,44.3333L 25.3333,50.6667L 31.6667,50.6667L 31.6667,44.3333 Z M 44.3333,31.6667L 38,31.6667L 38,38L 44.3333,38L 44.3333,31.6667 Z M 38,31.6667L 38,25.3333L 31.6667,25.3333L 31.6666,31.6667L 38,31.6667 Z M 31.6666,31.6667L 25.3333,31.6667L 25.3333,38L 31.6667,38L 31.6666,31.6667 Z "
      />
    </svg>
  </div>
  {#if show}
    <div
      class="range absolute -bottom-10 -left-2 z-50 flex rounded-md px-2 py-4"
      on:click|stopPropagation
      on:keypress|stopPropagation
    >
      <input
        type="range"
        style={`background:linear-gradient(to right, #E24D72 ${t * 100}%, #ccc ${t * 100}%)`}
        min="0"
        max="1"
        step="0.01"
        bind:value={t}
        on:input={updateOpacity}
      />
    </div>
  {/if}
</div>

<svelte:window on:click={detectWindowClick} />

<style>
  .range {
    width: 150px;
    background: #fff;
  }

  input[type='range'] {
    /* removing default appearance */
    -webkit-appearance: none;
    appearance: none;
    /* creating a custom design */
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 15px;
    /*  overflow: hidden;  remove this line*/

    /* New additions */
    height: 5px;
    background: #ccc;
  }

  /* Thumb: webkit */
  input[type='range']::-webkit-slider-thumb {
    /* removing default appearance */
    -webkit-appearance: none;
    appearance: none;
    /* creating a custom design */
    height: 15px;
    width: 15px;
    background-color: #ffdde5;
    border-radius: 50%;
    border: none;

    /* box-shadow: -407px 0 0 400px #f50; emove this line */
    transition: 0.2s ease-in-out;
  }

  /* Thumb: Firefox */
  input[type='range']::-moz-range-thumb {
    height: 15px;
    width: 15px;
    background-color: #ffdde5;
    border-radius: 50%;
    border: none;

    /* box-shadow: -407px 0 0 400px #f50; emove this line */
    transition: 0.2s ease-in-out;
  }
</style>
